const checkListItemType = {
    USER : 0,

    REQUIRED : 1,

    SUGGESTED_ACTIVE : 2,

    SUGGESTED_INACTIVE : 3

};

angular.module('gw-um-j2js')
    .constant('checkListItemType', checkListItemType);